// colors used in app

export const Colors = {
  primary: "#007CA4",
  secondary: "#FFAA2A",
  white: "#fff",
  black: "#000",
  textColor: "#064061",
  textGreen: "#129047",
};
